/**
 * Resolves the public share URL for a client-review token.
 *
 * Lives in its own lib module (not inline in the component) so the
 * `import.meta.env` read stays out of component files — components that read
 * import.meta directly can't be imported under ts-jest's CommonJS transform.
 */
const API_URL = import.meta.env.VITE_API_URL || 'https://api.overlayqa.com';

export function reviewShareUrl(token: string): string {
  return `${API_URL}/api/review/${token}`;
}
